"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.exportToCsv = void 0;
var sanitizeFields = function (row) {
    return row.map(function (field) {
        // Escape quotes.
        var sanitizedField = ("" + field).replace(/"/g, '""');
        // Wrap the whole field in quotes if it contains problematic characters (quotes, commas, newlines).
        var pattern = /("|,|\n)/g;
        if (pattern.test(sanitizedField)) {
            sanitizedField = "\"" + sanitizedField + "\"";
        }
        return sanitizedField;
    });
};
var exportToCsv = function (_a) {
    var data = _a.data, _b = _a.filename, filename = _b === void 0 ? 'csv-export.csv' : _b, _c = _a.headers, headers = _c === void 0 ? [] : _c;
    var serializedHeaders = headers.length ? sanitizeFields(headers).join(',') + "\n" : '';
    // Iterate over each row and then each field within.
    var serializedRows = data.map(sanitizeFields).join('\n');
    var serializedData = serializedHeaders + serializedRows;
    var csvFile = new Blob([serializedData], {
        type: 'text/csv'
    });
    // Trigger file download.
    var tempAnchor = document.createElement('a');
    tempAnchor.download = filename;
    tempAnchor.href = window.URL.createObjectURL(csvFile);
    tempAnchor.style.display = 'none';
    document.body.appendChild(tempAnchor);
    tempAnchor.click();
    document.body.removeChild(tempAnchor);
    return serializedData;
};
exports.exportToCsv = exportToCsv;
